@if (courseTrack) {
  <div class="quiz-results-page">
    <!-- Header with breadcrumb and progress -->
    <ut-academy-header
      [title]="headerTitle"
      [showProgress]="isPartOfLearningTrack"
      [currentProgress]="trackCoursesCompleted"
      [totalItems]="trackCoursesTotal"
      (backClick)="onBackToTracks()">
    </ut-academy-header>
    @if (isLockedByOrder) {
      <ut-academy-course-locked [learningTrackName]="courseTrack.learning_track_name"></ut-academy-course-locked>
    } @else {
    <!-- Main Content Area: Results + Sidebar -->
    <div class="quiz-results-layout">
      <!-- Left: Quiz Results Content -->
      <section class="quiz-results-main" aria-label="Quiz results content">
        <div class="quiz-results-container">
          <!-- Header -->
          <div class="quiz-results-header">
            <h2 class="quiz-results-title">Quiz: {{ courseTrack.name }}</h2>
            <p class="quiz-results-subtitle">
              Test your knowledge with this quiz to complete the course.
            </p>
          </div>
          <hr class="quiz-results-divider">
          <!-- Banner Image -->
          <div class="quiz-results-banner">
            <img [src]="bannerImage" [alt]="bannerAlt">
          </div>
          <!-- Quiz Results -->
          <h3 class="quiz-results-heading">Quiz Results</h3>
          <div class="quiz-results-list">
            @for (result of sortedResults; track result; let i = $index) {
              <div>
                <ut-academy-quiz-result-item
                  [questionNumber]="i + 1"
                  [totalQuestions]="totalQuestions"
                  [question]="getQuestion(result)"
                  [result]="result"
                  (reviewLessonClicked)="onReviewLesson($event)">
                </ut-academy-quiz-result-item>
              </div>
            }
          </div>
          <!-- Footer CTA: Next Course or Return to Course Catalog -->
          @if (passed) {
            <div class="quiz-results-footer">
              @if (showNextCourse) {
                <button
                  type="button"
                  class="next-course-btn"
                  (click)="onNextCourse()">
                  Next Course
                  <svg class="next-icon" width="17" height="13" viewBox="0 0 17 13" fill="none"
                    xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M16.1666 4.16634H4.91663C2.84556 4.16634 1.16663 5.84527 1.16663 7.91634C1.16663 9.98741 2.84556 11.6663 4.91663 11.6663H8.66663M16.1666 4.16634L12.8333 0.833008M16.1666 4.16634L12.8333 7.49967"
                      stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
              }
              @if (showReturnToTracks) {
                <button
                  type="button"
                  class="return-to-tracks-btn"
                  (click)="onBackToTracks()">
                  Return to Course Catalog
                  <svg class="return-icon" width="17" height="13" viewBox="0 0 17 13" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M0.833374 4.16634H12.0834C14.1544 4.16634 15.8334 5.84527 15.8334 7.91634C15.8334 9.98741 14.1544 11.6663 12.0834 11.6663H8.33337M0.833374 4.16634L4.16671 0.833008M0.833374 4.16634L4.16671 7.49967" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
              }
            </div>
          }
        </div>
      </section>
      <!-- Right: Course Content Sidebar -->
      <aside class="quiz-results-sidebar" aria-label="Course information">
        <ut-course-content-sidebar
          [courseTrack]="courseTrack"
          [currentLessonId]="null"
          [showSignUpConfirmation]="showSignUpConfirmation"
          (lessonClick)="onLessonClick($event)"
          (quizClick)="onQuizClick()"
          (cycleSignUp)="onCycleSignUp()"
          (cycleSignUpConfirm)="onCycleSignUpConfirm()">
        </ut-course-content-sidebar>
      </aside>
    </div>
    }
  </div>
}
